import DOMPurify from "dompurify";

export const escapeHtml = (unsafe: string): string => {
  return unsafe
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
};

export const unescapeHtml = (safe: string): string => {
  return safe
    .replaceAll("&amp;", "&")
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&quot;", '"')
    .replaceAll("&#039;", "'");
};

/**
 * Sanitizes Algolia search result HTML for safe use in dangerouslySetInnerHTML.
 *
 * Algolia highlights matching text by wrapping it in <mark> tags. We need to
 * preserve those while stripping everything else. DOMPurify handles the full
 * spectrum of attack vectors — dangling open tags, attribute injection, nested
 * tags, encoding tricks — that the previous regex-based approach could not.
 */
export const escapeSearchResults = (hit: string): string => {
  return DOMPurify.sanitize(hit, {
    ALLOWED_TAGS: ["mark"],
    ALLOWED_ATTR: [],
  });
};
